import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';
import { get_cotizacion, get_cotizacion_compartida } from 'views/components/mm_pro/empresa/cotizacion/clase_cotizaciones';
import { get_cotizacion_contratada } from 'views/components/mm_pro/empresa/cotizacion/clase_contratacion';

require('moment/locale/es');

Vue.prototype.moment = moment;

Vue.use(Vuex);
const { getFieldDetalle, updateFieldDetalle } = createHelpers({
  getterType: 'getFieldDetalle',
  mutationType: 'updateFieldDetalle',
});

export default {
  namespaced: true,
  state: {
    calificacion: {},
    confirmacion: {},
    contrato: get_cotizacion_contratada(),
    cotizacion_compartida: get_cotizacion_compartida(),
    cotizacion: get_cotizacion(),
    count_cotizaciones_por_empresa: 0,
    descuento_solicitud: { aplicar_descuento: 0 },
    empresa: { empresa_datos: {}, membresia_paga: 0, tipo_membresia: {} },
    feature_flag_quote_required: false,
    ha_enviado_cotizacion: false,
    lista_muebles_inventario: [],
    llamada: {},
    maximo_numero_cotizaciones: 10,
    mensajes: [],
    modulo_descuentos_esta_encendido: false,
    notas_cliente_contrato: {},
    notas: [],
    solicitud_comprada: {},
    solicitud: {
      correo: '',
      elevador_carga: null,
      elevador_descarga: null,
      inmueble_destino: {},
      inmueble_origen: {},
      inventario: [],
      marcas: [],
      piso_carga: null,
      piso_descarga: null,
      tipo_elevador_carga: {},
      tipo_elevador_descarga: {},
      tipo_piso_carga: {},
      tipo_piso_descarga: {},
    },
    tipo_precios_a_enviar: { exclusiva: true, compartida: false },
    vehiculosEmpresa: [],
  },
  getters: {
    getFieldDetalle,
  },
  mutations: {
    updateFieldDetalle,
  },
};
